import React, { useState } from 'react';

import { Button, Props } from '.';

/** shows loading state while onClick promise is being resolved  */
export function AsyncButton({ onClick, ...otherProps }: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const handleOnClick: Props['onClick'] = async (ev) => {
    if (onClick) {
      try {
        setIsLoading(true);
        await onClick(ev);
      } finally {
        setIsLoading(false);
      }
    }
  };
  return <Button onClick={handleOnClick} loading={isLoading} {...otherProps} />;
}
